export const HEALTH_MATTERS_NEWSLETTER = 'Health Matters Newsletter';
export const VIEW_LATEST_ISSUE =
  'View latest issue of Health Matters Newsletter to guide you through your personalized wellness plan.';
export const ISSUES = 'Issues';
export const READ_LATEST_ISSUE = 'Read latest issue';
export const UPLOADED = 'Uploaded';
export const OPEN_ERROR_MODAL = 'Open Error Modal';
export const WENT_WRONG = 'Oops! Something went wrong.';
export const ERROR_MESSAGE = 'We’re sorry, but an unexpected error has occured';
export const PLEASE_TRY_AGAIN = 'Please try again';
export const OK = 'OK';
export const ENGEN = 'engen';
